/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Détail d'une garantie
 * @export
 * @interface CoverageDetailDto
 */
export interface CoverageDetailDto {
    /**
     * Niveau de la garantie
     * @type {string}
     * @memberof CoverageDetailDto
     */
    level?: string;
    /**
     * Taux de remboursement
     * @type {string}
     * @memberof CoverageDetailDto
     */
    reimbursementRate?: string;
    /**
     * Plafond de remboursement
     * @type {string}
     * @memberof CoverageDetailDto
     */
    ceiling?: string;
    /**
     * Description de la garantie
     * @type {string}
     * @memberof CoverageDetailDto
     */
    description?: string;
}

/**
 * Check if a given object implements the CoverageDetailDto interface.
 */
export function instanceOfCoverageDetailDto(value: object): value is CoverageDetailDto {
    return true;
}

export function CoverageDetailDtoFromJSON(json: any): CoverageDetailDto {
    return CoverageDetailDtoFromJSONTyped(json, false);
}

export function CoverageDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'level': json['level'] == null ? undefined : json['level'],
        'reimbursementRate': json['reimbursementRate'] == null ? undefined : json['reimbursementRate'],
        'ceiling': json['ceiling'] == null ? undefined : json['ceiling'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CoverageDetailDtoToJSON(json: any): CoverageDetailDto {
    return CoverageDetailDtoToJSONTyped(json, false);
}

export function CoverageDetailDtoToJSONTyped(value?: CoverageDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': value['level'],
        'reimbursementRate': value['reimbursementRate'],
        'ceiling': value['ceiling'],
        'description': value['description'],
    };
}

